import * as React from 'react';
import URLHelpers from '../components/shared/url_helpers';
import BillingMethod from './billing_method';
import Location from '../lib/wrapped_location';
import QueryParamsUtil from '../reverb-js-common/query_params_util';

function onBillingMethodUpdateComplete() {
  const url = URLHelpers.mySellingStatementsPath({ invoice_success: true });
  const redirect = QueryParamsUtil.getParamValue('redirect_to', Location.href);
  // need a full page refresh to flush rails view data on the statements page

  Location.assign(redirect || url);
}

export default function StatementBillingMethod() {
  const redirect = QueryParamsUtil.getParamValue('redirect_to', Location.href);

  return (
    <BillingMethod
      data-billing-method
      onUpdateBillingMethodSuccess={onBillingMethodUpdateComplete}
      returnURL={URLHelpers.mySellingStatementsPath({ redirect_to: redirect })}
      showEditURL
    />
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/billing/statement_billing_method.tsx